MultiStepForm[3] = {
  birth_date: false,
  nationality: false,
  gender: false,
  marital_status: false,
  phone_plan: false,
  // dependant_count: false, // This field seems unused based on HTML
}

let birthdate_value = ""

const getAge = (value) => {
  const today = new Date()
  const birthDate = new Date(value)

  // Basic check for valid date object
  if (isNaN(birthDate.getTime())) {
      return 0;
  }

  const birthDateStr =
    birthDate.getFullYear() +
    "-" +
    ("0" + (birthDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + birthDate.getDate()).slice(-2)

  // Ensure the reconstructed date matches the input to catch invalid days/months
  if (value !== birthDateStr) {
    return 0
  }

  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

const validateBirthDate = () => {
  const day = document.getElementById("birth_date-day").value
  const month = document.getElementById("birth_date-month").value
  const year = document.getElementById("birth_date-year").value

  // Ensure all parts are selected
  if (!day || !month || !year) {
      return false;
  }

  const value = year + "-" + month + "-" + day
  // Check length just in case (should be YYYY-MM-DD)
  if (value.length == 10) {
    birthdate_value = day + "-" + month + "-" + year // Format for hidden input

    const age = getAge(value)
    return age >= 18 && age <= 80 // Validate age range
  }

  return false
}

jQuery(document).ready(function ($) {
  // Gender validation - Target radio inputs by name within the step form
  $("body").on("change", '#form-step-3 input[name="LeadForm[gender]"]', function () {
    const name = $(this).data("name") // Should be 'gender'
    const field = "Genero"; // Hardcode label for error message consistency

    // Check if any radio button in the group is checked
    if ($('#form-step-3 input[name="LeadForm[gender]"]:checked').length > 0) {
      showSuccess(3, name)
    } else {
      // This case might not be reachable with radios but included for completeness
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, "", message)
    }
  })

  // Phone plan validation - Target radio inputs by name within the step form
  $("body").on("change", '#form-step-3 input[name="LeadForm[phone_plan]"]', function () {
    const name = $(this).data("name") // Should be 'phone_plan'
    const field = "Tipo de contrato"; // Hardcode label

    // Check if any radio button in the group is checked
     if ($('#form-step-3 input[name="LeadForm[phone_plan]"]:checked').length > 0) {
      showSuccess(3, name)
      // Update hidden input if it exists (though none shown in HTML for this)
      // $("#form-toggle-phone_plan").val($(this).val())
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, "", message)
    }
  })

  // Birth date validation
  $("body").on("change", "#form-date-step-3 select", function (event) {
    const name = "birth_date"; // Hardcode name for consistency
    if (validateBirthDate()) {
      // Update the hidden input field with the formatted date
      $(`#LeadForm-${name}`).val(birthdate_value)
      showSuccess(3, name)
    } else {
      const message = "Por favor, ingresa una fecha de nacimiento válida (entre 18 y 80 años)."
      // Clear hidden input if date is invalid
      $(`#LeadForm-${name}`).val("");
      showError(3, name, "Fecha de nacimiento", "", message)
    }
  })

  // General selector validation (covers nationality, marital_status)
  $("body").on("change", "#form-selector-step-3 select", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    // Use the select's ID to find the associated label for a better field name
    const fieldLabel = $(`label[for='${this.id}']`).text().replace('*','').trim();
    const field = fieldLabel || $(this).data("label").replace(/-/g, " ").toLowerCase() // Fallback

    if (value) {
      showSuccess(3, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, value, message)
    }
  })

  // --- Button Handlers ---
  $("body").on("click", "#submit-button-step-3", function (event) {
    event.preventDefault()
    submitForm(3)
  })

  $("body").on("click", "#previous-button-step-3", function (event) {
    event.preventDefault()
    showPreviousForm(2)
  })

  $("body").on("click", "#mobile-previous-button-step-3", function (event) {
    event.preventDefault()
    showPreviousForm(2)
  })

  $("body").on("click", "#sidebar-step-2", function (event) {
    event.preventDefault()
    showPreviousForm(2, "sidebar")
  })
})
